'use client';

import React from 'react';
import Image from 'next/image';

type TextInputWithButtonProps = {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  maxLength?: number;

  placeholder?: string;
  formatter?: (value: string) => string;
  disabled?: boolean;
  isPending?: boolean;
  disabledTitle?: string;

  enabledTitle?: string;
};

export const TextInputWithButton: React.FC<TextInputWithButtonProps> = ({
  value,
  onChange,
  onSubmit,
  maxLength,
  placeholder = 'Digite o valor',
  formatter,
  disabled = false,
  isPending = false,
  disabledTitle = 'Ação indisponível',
  enabledTitle = 'Enviar',
}) => {
  const canClick = !disabled && !isPending;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const formatted = formatter ? formatter(raw) : raw;
    onChange(formatted);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && canClick) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        maxLength={maxLength}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className="w-full border-2 border-gray-300 rounded-lg py-4 pl-4 pr-12 text-sm focus:outline-none focus:ring-2 focus:ring-bluecaixa"
      />
      <button
        type="button"
        onClick={onSubmit}
        className="absolute right-3 top-1/2 -translate-y-1/2 disabled:opacity-50"
        aria-label={enabledTitle}
        disabled={!canClick}
        title={canClick ? enabledTitle : disabledTitle}
      >
        <Image
          src="/icons/send.png"
          alt="Enviar"
          width={20}
          height={20}
          className="hover:scale-110 transition-transform"
        />
      </button>
    </div>
  );
};
